import { create } from 'zustand'

type DefaultTimeKind = 'default_start_hour' | 'default_end_hour'
export interface IBookingHourState {
  default_start_hour: Date
  default_end_hour: Date
  setDefaultHour: (value: Date, kind: DefaultTimeKind) => void
}
export const useBookingHourState = create<IBookingHourState>((set) => ({
  default_start_hour: new Date(),
  default_end_hour: new Date(),
  setDefaultHour: (value: Date, kind: DefaultTimeKind) => {
    set({ [kind]: value })
  },
}))
